document.addEventListener("DOMContentLoaded", () => {
  const video = document.querySelector(".ninja-compare__video video");
  if (!video) return;

  const playBtn = document.querySelector(".ninja-video-play");
  const muteBtn = document.querySelector(".ninja-video-mute");

  // SVG icons instead of emoji for consistent sizing
  const iconPlay = `<svg width="12" height="12" viewBox="0 0 12 12" fill="currentColor">
    <polygon points="2,1 11,6 2,11"/>
  </svg>`;
  const iconPause = `<svg width="12" height="12" viewBox="0 0 12 12" fill="currentColor">
    <rect x="1" y="1" width="4" height="10"/><rect x="7" y="1" width="4" height="10"/>
  </svg>`;
  const iconMute = `<svg width="13" height="13" viewBox="0 0 13 13" fill="currentColor">
    <path d="M1 4.5h2.5L7 1.5v10L3.5 8.5H1zM9.5 4.5l2.5 2.5M12 4.5L9.5 7"/>
    <line x1="9.5" y1="4.5" x2="12" y2="7" stroke="currentColor" stroke-width="1.5"/>
    <line x1="12" y1="4.5" x2="9.5" y2="7" stroke="currentColor" stroke-width="1.5"/>
  </svg>`;
  const iconUnmute = `<svg width="13" height="13" viewBox="0 0 13 13" fill="currentColor">
    <path d="M1 4.5h2.5L7 1.5v10L3.5 8.5H1z"/>
    <path d="M9 3.5c1.5 0.8 2.5 2.3 2.5 4s-1 3.2-2.5 4" 
      fill="none" stroke="currentColor" stroke-width="1.4"/>
  </svg>`;

  // Set initial icons
  playBtn.innerHTML = iconPause;
  muteBtn.innerHTML = iconMute;

  playBtn.addEventListener("click", () => {
    if (video.paused) {
      video.play();
      playBtn.innerHTML = iconPause;
    } else {
      video.pause();
      playBtn.innerHTML = iconPlay;
    }
  });

  muteBtn.addEventListener("click", () => {
    video.muted = !video.muted;
    muteBtn.innerHTML = video.muted ? iconMute : iconUnmute;
  });
});